import { ISnackbarState } from '../../types/snackbar';
import { ADD_SNACKBAR_MESSAGE, REMOVE_SNACKBAR_MESSAGE } from '../actions/snackbar';

const initialState: ISnackbarState = {
  messages: [],
};

const reducer = (state: ISnackbarState = initialState, action: any) => {
  switch (action.type) {
    case ADD_SNACKBAR_MESSAGE: {
      const { payload } = action;
      return {
        ...state,
        messages: [...state.messages, payload],
      };
    }
    case REMOVE_SNACKBAR_MESSAGE: {
      return {
        ...state,
        messages: state.messages.slice(1),
      };
    }
    default:
      return state;
  }
};

export default reducer;
